import {
  pgTable,
  serial,
  timestamp,
  varchar,
  text,
  decimal,
  integer,
  boolean,
  jsonb
} from "drizzle-orm/pg-core"
import { PAGE_LAYOUTS } from "$types/PAGE_LAYOUTS"
import { eventsTable } from "./Events"
import { relations } from "drizzle-orm"
import { customersLogosTable } from "./CustomersLogos"
import { DynamicFormConfig } from "$types/dynamic-form"

export const pagesTable = pgTable("Pages", {
  id: serial().primaryKey(),
  creationTimestamp: timestamp({ withTimezone: true }).notNull().defaultNow(),

  systemPrompt: text("systemPrompt").notNull().default(""),
  url: varchar("url", { length: 255 }).notNull().default("").unique(),
  title: varchar("title", { length: 255 }).notNull().default(""),
  content: text("content").notNull().default(""),
  followUpQuestions: text("followUpQuestions").notNull().default(""),
  layout: varchar("layout", { length: 255 }).$type<PAGE_LAYOUTS>().notNull().default(PAGE_LAYOUTS.BASIC),
  metadata: text("metadata").notNull().default(""),
  smallDescription: text("smallDescription").notNull().default(""),
  firstIterationInputPromptPlaceholder: varchar("firstIterationInputPromptPlaceholder", { length: 255 }).notNull().default(""),
  subsequentIterationsInputPromptPlaceholder: varchar("subsequentIterationsInputPromptPlaceholder", { length: 255 }).notNull().default(""),
  priority: decimal("priority", { precision: 3, scale: 2 }).notNull().default("0.90"),
  allowIndexing: boolean("allowIndexing").notNull().default(true),
  showInSitemap: boolean("showInSitemap").notNull().default(true),

  titleMetadata: text().notNull().default(""),
  descriptionMetadata: text().notNull().default(""),
  
  // EVENTS PAGES
  eventId: integer().references(() => eventsTable.id, { onDelete: "set null" }),

  // CASE STUDIES PAGES
  customerLogoId: integer().references(() => customersLogosTable.id, { onDelete: "set null" }),
  shortDescription: text().notNull().default(""),

  vertical: text().notNull().default(""),

  publishedAt: timestamp({ withTimezone: true }),
  hideTitle: boolean().notNull().default(false),

  publishedInSidebarAt: timestamp({ withTimezone: true }),
  sidebarOrder: integer(),

  formConfig: jsonb().$type<DynamicFormConfig>(),
  formPublishedAt: timestamp({ withTimezone: true }),

  lang: varchar("lang"),
  publicSubmissions: timestamp({ withTimezone: true }),
  publicSubmissionsUUID: varchar("publicSubmissionsId", { length: 255 }),
  publicSubmissionsPassword: varchar("publicSubmissionsPassword", { length: 255 }),
})

export const pagesRelations = relations(
  pagesTable,
  ({ one }) => ({
    event: one(eventsTable, {
      fields: [pagesTable.eventId],
      references: [eventsTable.id],
    }),
    customerLogo: one(customersLogosTable, {
      fields: [pagesTable.customerLogoId],
      references: [customersLogosTable.id],
    }),
  }),
)

export type PageSchema = typeof pagesTable.$inferSelect
export type NewPageSchema = typeof pagesTable.$inferInsert
